import { getToken } from '@helpscout/hsds-tokens/getToken'
import styled from 'styled-components'

import Button from 'hsds/components/button'
import { shadow50, shadowInverted50 } from 'hsds/utils/mixins'

/**
 * Header and Footer layout
 */
export const HeaderUI = styled('header')`
  ${shadow50};
  --hsds-simpleModal-header-height: 58px;
  height: var(--hsds-simpleModal-header-height);
  padding: 0 24px;
  background-color: ${getToken('simpleModal.color.background.body')};
  border-radius: ${getToken('radius.overlay')} ${getToken('radius.overlay')} 0 0;
  flex-shrink: 0;
  flex-grow: 0;
  width: 100%;
  z-index: 3;

  &:not(.with-custom-header-content) {
    display: flex;
    justify-content: center;
    flex-direction: column;
  }

  h1 {
    margin: 0;
    font-weight: 500;
    font-size: 16px;
    color: ${getToken('simpleModal.color.heading')};
  }
`

export const BodyUI = styled('div')`
  padding: 40px 90px;
  width: 100%;
  flex-grow: 1;
  overflow-y: auto;
  overscroll-behavior-y: contain;

  // @container is not working with the current jsdom version
  // I don't feel like trying to fight that for now
  // @container simplemodal-body (max-width: 700px) {
  // padding: 20px 40px;
  // }
`

export const FooterUI = styled('footer')`
  ${shadowInverted50};
  --hsds-simpleModal-footer-height: 70px;
  height: var(--hsds-simpleModal-footer-height);
  padding: 0 24px;
  background-color: ${getToken('simpleModal.color.background.footer')};
  border-radius: 0 0 ${getToken('radius.overlay')} ${getToken('radius.overlay')};
  flex-shrink: 0;
  flex-grow: 0;
  width: 100%;
  z-index: 3;
`

export const HeaderFooterContainerScrollUI = styled('div')`
  display: flex;
  flex-direction: column;
  flex: 1 1 auto;
  overflow: hidden;
  width: 100%;
  /* container-type: size;
  container-name: simplemodal-body; */
`

/**
 * Confirmation layout
 */
export const ConfirmationWrapperUI = styled('div')`
  display: flex;
  flex-direction: column;
  height: 247px;
  width: 440px;
  padding: 50px 50px 60px 50px;
  justify-content: center;

  &.is-compact {
    height: 197px;
  }
`

export const ConfirmationHeadingUI = styled('h1')`
  color: ${getToken('simpleModal.color.heading')};
  font-size: 18px;
  font-weight: 500;
  text-align: center;
  margin: 0 0 6px 0;

  .is-compact & {
    margin-bottom: 25px;
  }
`

export const ConfirmationBodyUI = styled('div')`
  color: ${getToken('simpleModal.color.confirmationBody')};
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  font-weight: 400;
  margin-bottom: 25px;
`

export const ConfirmationFooterUI = styled('footer')`
  display: flex;
  justify-content: center;
  gap: 10px;
`

export const ButtonUI = styled(Button)`
  --hsds-button-min-width: 110px;
`
